import { Card } from '../ui/card';
import { Star } from 'lucide-react';
import { mockTestimonials } from '../../mock/mock';

export const TestimonialsSection = () => (
  <section id="temoignages" className="testimonials-section">
    <div className="section-container">
      <div className="section-header">
        <span className="section-label">Témoignages</span>
        <h2 className="section-title">Avis Clients - Laura Body Naturopathe Angoulême</h2>
        <a href="https://www.google.com/search?q=Laura+Body+Naturopathe+Angoul%C3%AAme+avis" className="google-rating-banner" data-testid="google-rating-banner">
          <div className="google-rating-badge">
            <span className="google-rating-number">5</span>
            <span className="google-rating-max">/5</span>
          </div>
          <div className="google-rating-details">
            <div className="google-rating-stars-row">
              {[...Array(5)].map((_, i) => (
                <Star key={`banner-star-${i}`} className="google-star-banner" fill="currentColor" />
              ))}
            </div>
            <span className="google-rating-label">Note Google - 12 avis</span>
          </div>
        </a>
      </div>
      <div className="testimonials-grid">
        {mockTestimonials.map((testimonial) => (
          <Card key={testimonial.name} className="testimonial-card">
            <div className="testimonial-header">
              <div className="testimonial-avatar">
                {testimonial.name.charAt(0)}
              </div>
              <div>
                <h4 className="testimonial-name">{testimonial.name}</h4>
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={`testimonial-star-${i}`} className="star-icon" fill="currentColor" />
                  ))}
                </div>
              </div>
            </div>
            <p className="testimonial-text">{testimonial.text}</p>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
